import CookieCategories from './cookie-categories'

export default CookieCategories
